import axios from 'axios';
import { API_CONFIG } from '../config/env';

export interface WalletBalance {
  address: string;
  /** Escrow USDC balance on Polygon (field name kept for existing callers). */
  usdtBalance: number;
  maticBalance: number;
}

class WalletService {
  private getAuthHeaders() {
    const token = localStorage.getItem('accessToken');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }

  async getWalletBalance(address: string): Promise<WalletBalance> {
    try {
      const response = await axios.get(`${API_CONFIG.BASE_URL}/Wallets/${address}/balance`, {
        headers: this.getAuthHeaders(),
      });
      const data = response.data as Record<string, unknown>;
      const usdc =
        typeof data.usdcBalance === 'number'
          ? data.usdcBalance
          : typeof data.usdtBalance === 'number'
            ? data.usdtBalance
            : 0;
      const matic = typeof data.maticBalance === 'number' ? data.maticBalance : 0;
      return {
        address: typeof data.address === 'string' ? data.address : address,
        usdtBalance: usdc,
        maticBalance: matic,
      };
    } catch (error) {

      throw error;
    }
  }
}

export const walletService = new WalletService();
